export default __webpack_public_path__ + "static/media/library-active.5cde50cd.svg";